module.exports = __webpack_public_path__ + "static/media/texture (7).f6fe185b.jpg";